module.exports = __webpack_public_path__ + "ae7cd7d2b8d33e9d0b266fe8023ab303.svg";